import type { Nullable } from "@sunrise/utils";
import { atom } from "jotai";

export const shakaPlayerAtom = atom<Nullable<shaka.Player>>(null);
